import { assert_error } from "@torus-network/torus-utils";
import { trySync } from "@torus-network/torus-utils/try-catch";
export function handleMapValues(rawEntries, schema) {
    const entries = [];
    const errors = [];
    for (const entry of rawEntries) {
        const [, valueRaw] = entry;
        const parseResult = schema.parse(valueRaw);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        const [error, parsed] = trySync(() => parseResult);
        if (error !== undefined) {
            errors.push(error);
            assert_error(error);
            continue;
        }
        entries.push(parsed);
    }
    return [entries, errors];
}
export function handleMapEntries(rawEntries, keySchema, valueSchema) {
    const entries = new Map();
    const errors = [];
    for (const entry of rawEntries) {
        const [keysRaw, valueRaw] = entry;
        const [key1Raw] = keysRaw.args;
        const [keyError, parsedKey] = trySync(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        () => keySchema.parse(key1Raw));
        if (keyError !== undefined) {
            errors.push(keyError);
            continue;
        }
        const [valueError, parsedVal] = trySync(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        () => valueSchema.parse(valueRaw));
        if (valueError !== undefined) {
            errors.push(valueError);
            continue;
        }
        entries.set(parsedKey, parsedVal);
    }
    return [entries, errors];
}
export function handleDoubleMapEntries(rawEntries, key1Schema, key2Schema, valueSchema) {
    const entries = new Map();
    const errors = [];
    for (const entry of rawEntries) {
        const [keysRaw, valueRaw] = entry;
        const [key1Raw, key2Raw] = keysRaw.args;
        const [key1Error, parsedKey1] = trySync(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        () => key1Schema.parse(key1Raw));
        if (key1Error !== undefined) {
            errors.push(key1Error);
            continue;
        }
        const [key2Error, parsedKey2] = trySync(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        () => key2Schema.parse(key2Raw));
        if (key2Error !== undefined) {
            errors.push(key2Error);
            continue;
        }
        const [valueError, parsedVal] = trySync(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        () => valueSchema.parse(valueRaw));
        if (valueError !== undefined) {
            errors.push(valueError);
            continue;
        }
        if (!entries.has(parsedKey1)) {
            entries.set(parsedKey1, new Map());
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entries.get(parsedKey1).set(parsedKey2, parsedVal);
    }
    return [entries, errors];
}
